export default __webpack_public_path__ + "static/media/LOGOBUBLE_ONDES.e9a4488d.png";